module.exports = new __parcel__URL__("robinhood.50f8de49.webp").toString();